import React from "react";

import twMerge from "@replo/design-system/utils/twMerge";

import { CHAT_TOKEN_REGISTRY } from "./ChatTokenRegistry";
import { MarkdownRenderer } from "./MarkdownRenderer";
import { parseChatTokens } from "./parseChatTokens";

interface RichTextRendererProps {
  content: string;
  className?: string;
}

export const ChatTextRenderer: React.FC<RichTextRendererProps> = ({
  content,
  className,
}) => {
  const segments = parseChatTokens(content);

  return (
    <span className={twMerge("inline", className)}>
      {segments.map((segment) => {
        if (segment.type === "text") {
          return (
            <span key={segment.id} className="inline">
              <MarkdownRenderer inline>{segment.content}</MarkdownRenderer>
            </span>
          );
        }

        if (segment.type === "chat-token" && segment.elementData) {
          const { type, data } = segment.elementData;
          const TokenComponent = CHAT_TOKEN_REGISTRY[type];
          if (!TokenComponent) {
            return null;
          }

          return (
            <span key={segment.id} className="inline align-baseline px-2">
              <TokenComponent data={data} />
            </span>
          );
        }

        return null;
      })}
    </span>
  );
};
